export const environment = {
  production: false,
  cognito: {
    domain: 'https://eu-central-1p9vef53mk.auth.eu-central-1.amazoncognito.com',
    authority: 'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_p9Vef53Mk',
    clientId: '69eid1jlko9vi4tk23fvi4oc8k',
    redirectUrl: 'https://v1.demcfpd.dev.agco-opsmgmt.com/',
  },
  apiUrl: 'https://api.v1.demcfpd.dev.agco-opsmgmt.com',
};
